import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ContentModel } from './models/content.model';
import { AppListResponse } from '../shared/app.response';
import { BehaviorSubject } from 'rxjs';
import { DocumentTypeEnum } from '../../modules/shared/enums/document-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ContentsService {
  private apiUrl = `${environment.baseApimUrl}/document`;

  constructor(private http: HttpClient) {}

  private readonly storageKey = 'print-orientation';

  private dataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    localStorage.getItem(this.storageKey) || ''
  );

  public data$ = this.dataSubject.asObservable();

  updateData(data: any) {
    this.dataSubject.next(data);
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  getUpdateData(): Observable<any> {
    return this.data$;
  }

  deleteData() {
    this.dataSubject.next(null);
    localStorage.removeItem(this.storageKey);
  }

  getDocuments(
    pageNumber = 0,
    itensPerPage = 6,
    type: DocumentTypeEnum
  ): Observable<AppListResponse<ContentModel>> {
    const request = {
      SearchExpression: '',
      SortField: 'Order',
      Filters: [
        {
          Key: 'type',
          Operator: 'Equals',
          Value: type
        }
      ],
      SortOrder: 1,
      PageNumber: pageNumber,
      PageSize: itensPerPage
    };
    const url = `${this.apiUrl}/getall`;
    return this.http.post<AppListResponse<ContentModel>>(url, request);
  }

  downloadPdf(fileName: string, documentUrl: string): void {
    documentUrl = documentUrl.replace('&inline=1', '');

    fetch(documentUrl, { mode: 'no-cors' })
      .then(() => {
        window.open(documentUrl, '_blank');
      })
      .catch((error) => console.error('Erro ao abrir o PDF:', error));
  }
}
